import { Component, Inject, Input, OnInit } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() isHandheld: boolean = false;
  version?: string;

  constructor(@Inject(ENV_CONFIG) private config: EnvironmentConfig) { }

  environment?: string;
  year?: number;

  ngOnInit(): void {
    this.environment = this.config.environmentName;
    this.year = new Date().getFullYear();
    this.version = `v${this.config.appVersion}`;
  }

}
